import messages from '../../../locales/messages';
import { Link, ClickableTile } from 'carbon-components-react';
import PublicImage from 'src/common/components/PublicImage';
import './somethingElse.scss';
import { ArrowRight32 } from '@carbon/icons-react';
import { img_result } from '../../../constants/default';
import C4DVideoPlayerContainer from '@carbon/ibmdotcom-web-components/es/components-react/video-player/video-player-container';
import { createUseTranslation } from 'src/common/hooks/widgets/useTranslation';
import { useQradarEDRSelector } from '../../../lib/redux/hooks';
import * as VideosIDs from '../../../constants/default';

type SomethingElseProps = {
  contactSales: () => void;
  setDrawOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setFormID: React.Dispatch<React.SetStateAction<string>>;
};

export const SomethingElse = ({
  contactSales,
  setDrawOpen,
  setFormID,
}: SomethingElseProps) => {
  const AEMMessages = useQradarEDRSelector(
    (state) => state.translations.messages,
  );
  const useTranslation = createUseTranslation(messages, AEMMessages);
  return (
    <>
      <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-4 se_columns se_column01">
        <ClickableTile
          className="se_tile01"
          role="button"
          onClick={() => {
            contactSales();
          }}
        >
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <PublicImage
                imgPath={img_result}
                widgetId="ai-solutions-advisor"
                id="img01"
                alt="AI Solutions Advisor icon picture"
                className="se_imgs"
              />
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="se_textHeading">
                {useTranslation('se_col1_paragraph_01')}
              </p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="se_textSubHeading">
                {useTranslation('se_col1_paragraph_02')}
              </p>
            </div>
          </div>
          <div className="bx--row">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4 linkLine">
              <Link
                role="button"
                className="bx-link-class link_contactSales"
                id="se-next-step-id"
                rel="noreferrer"
                renderIcon={() => <ArrowRight32 className="Image" />}
                onClick={() => {
                  contactSales();
                }}
              />
            </div>
          </div>
        </ClickableTile>
      </div>
      <div className="bx--col-lg-8 bx--col-md-4 bx--col-sm-4 se_columns">
        <C4DVideoPlayerContainer
          aspectRatio="16x9"
          videoId={VideosIDs.videoId_background}
          playing-mode="inline"
          background-mode={true}
        />
        <div className="FloatTile">
          <div className="bx--row floatRow">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="floatTitle">
                {useTranslation('se_col2_paragraph_01')}
              </p>
            </div>
          </div>
          <div className="bx--row floatRow">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="floatTitle">
                {useTranslation('se_col2_paragraph_02')}
              </p>
            </div>
          </div>
          <div className="bx--row floatRow">
            <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-4">
              <p className="floatSubtitle">
                <span className="floatToken">
                  {useTranslation('se_col2_paragraph_03')}
                </span>
                <span className="floatToken">
                  {useTranslation('se_col2_paragraph_04')}
                </span>
                <span className="floatToken">
                  {useTranslation('se_col2_paragraph_05')}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
